export default async (context, { create_order, redirect}) => {

    context.error.status = false
    context.error.text = ''

    context.loading = true

    await context.$axios.get(`/check/phone/${context.phone}/code/${context.code}`)
        .then(async ({ data }) => {

            if(data.success) {
                context.overlay = false
                context.error.status = false
                context.error.text = ''
                await context.$store.dispatch('auth/setToken', {
                    token: data.tocken
                })
                if (create_order) { await context.auth_code_create_order(context) }
                if (redirect) { context.$router.push(redirect) }
            } else {
                context.overlay = true
                context.error.status = true
                context.error.text = data.error
                await context.$store.dispatch('auth/setToken', {
                    token: false
                })
                if (create_order) { await context.auth_code_create_order(context) }
                if (redirect)  { context.auth_code_clear_form(context) }
                context.loading = false
            }

        })
        .catch(e => {
            console.error(e)
            context.error.text = 'Ошибка сервера! Повторите попытку позже.'
            context.overlay = true
            context.error.status = true
            context.auth_code_clear_form(context)
        })
}